'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CoreNavigation = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _coreNavigationUi = require('../../redux/core-navigation-ui');

var _Masthead = require('../Masthead');

var _Masthead2 = _interopRequireDefault(_Masthead);

var _MastheadExtension = require('../MastheadExtension');

var _MastheadExtension2 = _interopRequireDefault(_MastheadExtension);

var _MainMenu = require('../MainMenu');

var _MainMenu2 = _interopRequireDefault(_MainMenu);

var _props2 = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global document */
/* eslint-disable import/no-named-as-default */
var CoreNavigation = exports.CoreNavigation = function (_Component) {
    (0, _inherits3.default)(CoreNavigation, _Component);

    function CoreNavigation() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, CoreNavigation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CoreNavigation.__proto__ || (0, _getPrototypeOf2.default)(CoreNavigation)).call.apply(_ref, [this].concat(args))), _this), _this.closeMenu = function (e) {
            if (!_this.node.contains(e.target) && _this.props.mainMenuOpened) {
                _this.props.dispatch(_coreNavigationUi.actions.toggleMainMenu());
            }
        }, _this.assignNode = function (node) {
            _this.node = node;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(CoreNavigation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('mousedown', this.closeMenu, false);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('mousedown', this.closeMenu, false);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                sectionName = _props.sectionName,
                sectionPath = _props.sectionPath,
                theme = _props.theme,
                skin = _props.skin,
                engagement = _props.engagement;
            var masthead = skin.masthead,
                mastheadExtension = skin.mastheadExtension,
                mainMenu = skin.mainMenu,
                importantSections = skin.importantSections,
                sectionsMenu = skin.sectionsMenu;


            return _react2.default.createElement(
                'header',
                {
                    className: theme.coreNavigation,
                    ref: this.assignNode,
                    'data-test-tag': '@spp/ui-core-navigation'
                },
                _react2.default.createElement(_Masthead2.default, {
                    theme: theme,
                    masthead: masthead,
                    importantSections: importantSections,
                    engagement: engagement
                }),
                _react2.default.createElement(_MastheadExtension2.default, {
                    theme: theme,
                    mastheadExtension: mastheadExtension,
                    importantSections: importantSections,
                    sectionsMenu: sectionsMenu,
                    sectionName: sectionName,
                    sectionPath: sectionPath,
                    engagement: engagement
                }),
                _react2.default.createElement(_MainMenu2.default, {
                    theme: theme,
                    mainMenu: mainMenu,
                    sectionsMenu: sectionsMenu,
                    engagement: engagement
                })
            );
        }
    }]);
    return CoreNavigation;
}(_react.Component);

if (process.env.NODE_ENV !== 'production') {
    CoreNavigation.propTypes = {
        mainMenuOpened: _propTypes2.default.bool.isRequired,
        dispatch: _propTypes2.default.func.isRequired,
        engagement: _propTypes2.default.func,
        sectionName: _propTypes2.default.string,
        sectionPath: _propTypes2.default.string,
        theme: _propTypes2.default.shape({
            coreNavigation: _propTypes2.default.string
        }),
        skin: _propTypes2.default.shape(_props2.skinProps).isRequired
    };
}

CoreNavigation.defaultProps = {
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    sectionName: undefined,
    sectionPath: undefined,
    theme: {}
};

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        loggedIn: state.spid.loggedIn,
        mainMenuOpened: state.coreNavigationUI.main.mainMenuOpened
    };
})(CoreNavigation);
//# sourceMappingURL=CoreNavigation.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/CoreNavigation/CoreNavigation.js
 ** module id = 311
 ** module chunks = 0
 **/